import React from 'react';
import Menu from '../menu';

const Index = ({ children }) => {
	return (
		<div>
			<Menu />
			{children}
		</div>
	);
};

export default Index;
